import React from 'react';
import MetricScorecard from './MetricScorecard';
import styles from './metricScorecardBar.module.css';

interface MetricScorecardBarProps {
  metrics: Array<{ label: string; value: number | string; subtitle?: string }>;
  variant?: 'navy' | 'orange';
}

const MetricScorecardBar: React.FC<MetricScorecardBarProps> = ({ metrics, variant = 'navy' }) => (
  <div className={styles.bar}>
    {metrics.map(m => (
      <MetricScorecard key={m.label} label={m.label} value={m.value} subtitle={m.subtitle} variant={variant} />
    ))}
  </div>
);

export default MetricScorecardBar;
